import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatButtonModule } from '@angular/material';
import { PushNotificationModalComponent } from './push-notification-modal.component';

@NgModule({
  declarations: [
    PushNotificationModalComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule
  ],
  entryComponents: [
    PushNotificationModalComponent
  ],
  exports: [
    PushNotificationModalComponent
  ]
})
export class PushNotificationModule { }
